import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/config/constants';
import { useAppStore } from '@/stores/app-store';

/**
 * Refetch the signed-in user's activity feed.
 *
 * Every persisting mutation writes a notification server-side, so the bell and the Recent activity
 * table are stale the moment a save succeeds. Call the returned function from a mutation's
 * `onSuccess`, alongside that mutation's own invalidations.
 *
 * It no-ops when nobody is signed in, so callers do not repeat the null check — which is the whole
 * reason this is shared rather than inlined at each of the sixteen call sites.
 */
export const useInvalidateNotifications = () => {
  const queryClient = useQueryClient();
  const userId = useAppStore((state) => state.currentUser?.id ?? null);

  return useCallback(() => {
    if (userId == null) return;
    void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notifications.list(userId) });
  }, [queryClient, userId]);
};
